import { InvoiceInfo, OrderInfo } from '../../../../../components/OrderCommon/interface';
import { LateCompensationLabel } from '../../../../../types/punctual';
import { UserGetMode } from '../../constants';

// 订单状态 Code
export const OrderStatus = {
  CREATED: 1, // 待支付
  PAYED: 2, // 等待商家接单中
  CONFIRMED: 3, // 商家已接单
  GRAB: 4, // 外送员赶往商家
  ARRIVAL: 5, // 外送员取餐中
  FETCH: 6, // 外送员送餐中
  FINISHED: 7, // 已完成
  CANCELED: 8, // 已取消 外卖&自提
  REFUND: 9, // 申请退款中
  PICKUP_WAIT_PAY: 10, // 自提-待支付
  PICKUP_WAIT_TAKE_ORDER: 11, // 自提-待接单
  PICKUP_SHOP_TAKE_ORDER: 12, // 自提-已接单
  PICKUP_SHOP_FOOD_READY: 13, // 自提-已出餐，待取餐
  PICKUP_ORDER_COMPLETE: 14, // 自提-已完成
};

// ======= **订单信息** =======
export interface AddressInfo {
  addressId: number;
  receiverPhone: string;
  receiverName: string;
  receiverLocation: string;
  receiverHouseNumber: string;
  receiverLongitude: number;
  receiverLatitude: number;
  receiverInnerCode: string;
  receiverAddress: string;
  addressLocationTips: string;
  unitNumber: string;
  buildingNumber: string;
  extra: any;
}

export interface OrderBaseInfo {
  deliveryServerText: string;
  expectedArrivalTime: string;
  orderViewId: string;
  orderTime: number;
  selectTablewareType: number;
  orderRemark: string;
  deliveryTimeText: string;
  pushText: string;
  payTypeText: string;
  tradeNo?: string; // 交易号
  orderSource: number;
  etpTime: string;
  pickupAddress: string;
  orderTimeStr: string;
  paySucceededTimeStr: string;
  privacyPhoneAvailable: number;
}

export interface OrderDetailData {
  orderInfo: OrderInfo;
  addressInfo: AddressInfo;
  orderBaseInfo: OrderBaseInfo;
  userGetMode: string;
  extra: any;
}

export interface PackagesInfo {
  details: PackagesInfoDetails[]; // 每个包裹的信息
  status: number; // 1: 所有包裹都是1个按钮的状态时. 用于不同UI的显示
}

export interface PackagesInfoDetails {
  id: string;
  number: number;
  title: string;
  riderInfo: PackageRiderInfo;
  buttons: ButtonInfo[];
  deliveryInfo: DeliveryInfo;
}

export interface DeliveryInfo {
  status: number; //状态 呼叫骑手/骑手赶往餐厅/骑手取餐中/骑手配送中/送达/包裹已取消
  desc: string;
  icon: string;
}

//  配送状态
export const DeliveryStatus = {
  CREATED: 0, // 已经创建
  DISPATCH: 10, // 呼叫骑手接单
  GRAB: 20, // 已抢单
  ARRIVAL: 25, // 已到店
  FETCH: 30, // 已取餐
  DELIVER: 50, // 已送达
  CANCELED: 99, // 已取消
};

export interface PackageRiderInfo {
  contactWayList: string[];
  latitude: string;
  longitude: string;
  imScheme: string;
}

// ======= **订单状态** =======
export interface OrderStatusInfo {
  orderStatus: number;
  orderStatusDesc: string;
  remainTime: number;
  orderSndDesc: string;
  showProgress: boolean;
  part: number;
  iconUrl: string;
}

export interface RefundPrice {
  amount: number;
  currency: string;
  displayAmount: string;
  displayText: string;
}

export interface RefundInfo {
  refundPrice: RefundPrice;
  afterSaleStatus: number;
  afterSaleDesc: string;
  afterSaleDescColor: string;
  clickUrl: string;
  afterSaleSndDesc: string;
  afterSaleId: string;
  afterSaleType: number;
  refundSpuDesc: string;
  reason: string; // 退款理由
  refuseReason: string; // 拒绝退款理由
}

export interface ButtonInfo {
  name: string;
  icon: string;
  clickUrl: string;
  code: number;
  highlight: number;
}

export interface DeliveryMapInfo {
  riderLat: number;
  riderLng: number;
  distance: number;
  estimatedTime: number;
  desc: string;
  waybillId?: string; // 运单号
}

export interface OrderOperateInfo {
  orderStatusInfo: OrderStatusInfo;
  operateButtonList: ButtonInfo[];
  showMap: boolean;
  refundType: number;
  pickupInfoList: PickupInfoItem[];
  pickupNumberStr: string;
}

interface PickupInfoItem {
  title: string;
  value: string;
  desc: string;
}

export interface TopBar {
  name: string;
  icon: string;
  clickUrl: string;
  code: number;
}

export interface ImEntranceInfo {
  imEntranceStatus: number;
  userDxUid: number;
  courierDxUid: number;
  userAppId: number;
  courierAppId: number;
}

export interface RiderInfo {
  contactWayList: string[];
  imEntranceInfo: ImEntranceInfo;
}

export interface ExtraInfo {
  etaDesc: string; // 送达时间显示
  etaExtDesc: string; // 已迟到
  paySucceededTime: number;
}

/**
 * 营销轮播卡片数据
 */
export interface MarketingBannerData {
  imgUrl?: string; // 图片url
  jumpUrl?: string; // 跳转链接
  activityId: number; // 活动配置id
  activityName?: string; // 活动名称
  bannerIndex: number; // 展示顺序
}

export interface OrderStatusData {
  orderOperateInfo: OrderOperateInfo;
  refundInfo: RefundInfo;
  refundList: RefundInfo[];
  deliveryMapInfo: DeliveryMapInfo;
  topBarList: TopBar[];
  riderInfo: RiderInfo;
  extraInfo: ExtraInfo;
  lateCompensationLabel: LateCompensationLabel;
  orderDetailPageBannerList?: MarketingBannerData[];
  tip?: string;
  userCsInfo: UserCSInfo;
  seq: number;
  userGetMode: UserGetMode;
  rushInfos: OrderRushData[];
  pickupMapInfo: PickupMapInfo;
  packageInfo: PackagesInfo;
  invoice: InvoiceInfo;
}

export interface PickupMapInfo {
  desc: string;
  dspPutContent: string;
}

export interface UserCSInfo {
  unReadCount: number;
}

export interface RequestErrorData {
  code?: number;
  message: string;
  msg?: string;
  type?: number; //异常类型，
}

export interface StoreReviewData {
  review: Boolean;
}

/// 重复支付 code
export const RepeatPayCode = 2000014;

export const RefundType = {
  FULL_REFUND: 0,
  PART_REFUND: 1,
};

/**
 * 多单任务弹窗数据
 */
export interface MultiOrderDialogData {
  taskId?: string;
  state: number; //任务状态 1：待领取任务；2：任务进行中；
  superStratumPictureUrl?: string; //预达标订单弹窗上层弹窗图片url
  subStratumPictureUrl?: string; //预达标订单弹窗下层弹窗图片url
  backgroundPictureUrl?: string; //参与弹窗背景图片url
  title?: string; //弹窗内容
  currentCompletedNodeNumber?: number; //当前完成节点数
  taskDetailUrl: string; //跳转任务落地页url
  actVersion?: number; //活动版本
  couponDetailDTOList?: MultiOrderDialogCoupon[]; //券列表
}

export interface MultiOrderDialogCoupon {
  couponType: number; //券类型
  couponAmountString: string;
  couponAmountText: string;
  currencyType: string; //券单位
  validTimeText: string; //有效期
  sillAmount: string; //使用门槛
}

export interface OrderDetailPopupData {
  popupsType: number; // 弹窗类型
  reviewsPopups: ReviewPopup; // 评价弹窗
}

export interface ReviewPopup {
  picture: string; // 头图
  subTitle: string; // 子标题
  scoreStarList: ScoreStar[]; // 星级集合
  isReviews: number; // 是否评价过
}

export interface ScoreStar {
  score: number; // 分数 1~5
  ref?: any;
}

// 催单数据
export interface OrderRushData {
  status: number; // 状态 1:骑手过近， 2远未超时，3即将/已超时, 4严重超时
  courierDxUid: string; // 骑手大象Id
  userDxUid: string; // 用户大象id
  contactWayList: any; // 联系方式
  bubbleMsg: string; // 气泡文案
  bubbleButtonMsg: string; // 气泡按钮文案
  disappearTime: number; // tips多少毫秒后消失
  frequencyTime: number; // 频控时间
  frequencyCount: number; // 频控次数
  rushMsg: string; // 催单内容
  halfLayer: OrderRushHalfLayer; // 半弹层数据
}

// 催单浮窗数据
export interface OrderRushHalfLayer {
  icon: string; // 头图
  title: string; // 标题
  msg: string; // 半弹层文案
  buttons: ButtonInfo[];
}
